import { create } from 'zustand';

interface LayoutStore {
  openNavMenu: boolean;
  setOpenNavMenu: (openNavMenu: boolean) => void;
  activeSearch: boolean;
  setActiveSearch: (activeSearch: boolean) => void;
  resetState: () => void;
}

const useLayoutStore = create<LayoutStore>((set) => ({
  openNavMenu: false,
  setOpenNavMenu: (openNavMenu: boolean) => set({ openNavMenu }),
  activeSearch: !!window?.location?.hash,
  setActiveSearch: (activeSearch: boolean) => set({ activeSearch }),
  resetState: () => {
    set({ openNavMenu: false, activeSearch: false });
  },
}));

export default useLayoutStore;
